export const CommonResourceURL = {
  //a common resource url is a url to content that is accessible throughout the app e.g.(pages, images, etc.)

  //@query params: ordId
  buyerViewSellerProfile: '/aptitude/buyer/BuyerViewSellerProfile',
  //@query params: rfpId
  buyerCompareSellers: '/aptitude/buyer/BuyerCompareSellers',
  //@query params: requestId
  buyerReviewContracts: '/aptitude/buyer/BuyerContracting',
  //@query params: requestId
  downloadBuyerPlanCSV:
    '/aptitude/buyer/PurchasePlanServiceController/download',
  //@query params: pId
  buyerViewProduct: '/aptitude/buyer/BuyerViewProduct',
  //Aptitude Rest API
  aptitudeApi: '/aptitude/api'
};
